import { Calendar, AlertCircle } from "lucide-react";
import { memo } from "react";

import { Badge, TabsList, TabsTrigger } from "@/common/components";

interface ModerationFiltersProps {
  requestsCount: number;
  // profileRequestsCount: number;
  retradeExtensionCount: number;
  requestCancellationCount: number;
}

export const ModerationFilters = memo(function ModerationFilters({
  requestsCount,
  // profileRequestsCount,
  retradeExtensionCount,
  requestCancellationCount,
}: ModerationFiltersProps) {
  return (
    <TabsList className="mb-6 flex flex-col md:flex-row item-start md:items-center justify-between md:justify-start h-32 md:h-10">
      <TabsTrigger value="requests" className="flex items-center gap-2 w-full md:w-fit">
        Заявки на модерации
        {requestsCount > 0 && (
          <Badge variant="secondary" className="bg-yellow-100 text-yellow-800 ml-2">
            {requestsCount}
          </Badge>
        )}
      </TabsTrigger>
      {/* <TabsTrigger value="profiles" className="flex items-center gap-2">
        <UserIcon className="h-4 w-4" />
        Профили на модерации
        {profileRequestsCount > 0 && (
          <Badge variant="secondary" className="bg-orange-100 text-orange-800 ml-2">
            {profileRequestsCount}
          </Badge>
        )}
      </TabsTrigger> */}
      <TabsTrigger value="retrade-extensions" className="flex items-center gap-2 w-full md:w-fit">
        <Calendar className="h-4 w-4" />
        Продление переторжки
        {retradeExtensionCount > 0 && (
          <Badge variant="secondary" className="bg-blue-100 text-blue-800 ml-2">
            {retradeExtensionCount}
          </Badge>
        )}
      </TabsTrigger>
      <TabsTrigger
        value="request-cancellations"
        className="flex items-center gap-2 w-full md:w-fit"
      >
        <AlertCircle className="h-4 w-4" />
        Отмена заявки
        {requestCancellationCount > 0 && (
          <Badge variant="secondary" className="bg-red-100 text-red-800 ml-2">
            {requestCancellationCount}
          </Badge>
        )}
      </TabsTrigger>
    </TabsList>
  );
});
